import { useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';

import { useMatchMedia } from './useMatchMedia';

const hideMenuPaths = [/login/, /offerings-drafts/];

export function useShowStaticMenu() {
  const isDesktopWide = useMatchMedia('xl');
  const pathname = useLocation({ select: (location) => location.pathname });

  return useMemo(() => {
    const isHideMenuPath = hideMenuPaths.some((path) => path.test(pathname));
    const analytics = pathname.startsWith('/analytics');
    if (analytics) {
      return false;
    }
    return isDesktopWide && !isHideMenuPath;
  }, [isDesktopWide, pathname]);
}
